import React from 'react'
import Layout from '../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const EnvironmentalChamber = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FmaterialTesting%2F12.png?alt=media&token=3efcc310-fc94-43c1-a34a-917458172c6b',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FmaterialTesting%2F12.png?alt=media&token=3efcc310-fc94-43c1-a34a-917458172c6b'
    ];

    return (
        <Layout>
            {/* Breadcrumb */}
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/instruments-materialtesting">Material Testing</a></li>
                </ul>
            </div>

            {/* Title */}
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Environmental Chamber</h1>
                </div>
            </div>

            {/* Main Section */}
            <section
                id="portfolio-details"
                className="portfolio-details"
                style={{ backgroundColor: 'white', marginBottom: '12rem' }}
            >
                <div className="container">
                    <div className="row gy-4">

                        {/* Image Slider */}
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img
                                                    src={src}
                                                    alt="UTM TC"
                                                    className="responsive"
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>

                        {/* Description */}
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Environmental Chamber</h3>

                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    Our Environmental or climatic chambers are specialized,
                                    enclosed, and controlled environments designed to simulate
                                    real-world environmental conditions—such as temperature,
                                    humidity, pressure, and sometimes UV— to test product
                                    reliability, stability, and accelerated aging in industries like
                                    Paper board, automobiles, constructions, defence, electronics,
                                    aerospace, pharmaceuticals, biotech, paints etc. <br /><br />
                                    Common tests include temperature cycling, humidity tests,
                                    corrosion testing (salt spray), altitude testing, and thermal
                                    shock. <br /><br />
                                    We offer walk in Environmental Chamber, Climatic chamber,
                                    thermal tests, salt spray chambers, corrosion chambers,
                                    laboratory &amp; Industrial ovens, test ovens, pharmaceutical
                                    stability chambers, rain chambers, dust chambers, IP tests,
                                    panel tests chambers, humidostatic chambers etc.
                                    They are available in standard as well as customized solutions.
                                    Their volume ranges from 48 Ltrs. to 8000 Ltrs / Temperature ranges
                                    from
                                    -- 70˚C to +180˚ C / Humidity ranges from 20% to 100% RH.

                                    <br /><br />

                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Environmental Chamber"
                                        style={{
                                            color: '#0d6efd',
                                            fontWeight: '600',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>

                            <div className="portfolio-description"></div>
                        </div>

                    </div>
                </div>
            </section>

            <br />
        </Layout>
    )
}

export default EnvironmentalChamber